/*
 * @Author: edconstdchen
 * @Date:   2016-02-26 15:49:13
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-08-16 17:29:21
 */
import assert from 'assert';
import _ from 'lodash';

const ifrTmpl = _.template(['<iframe data-src="${src}"',
  'width="${width}" height="${height}"></iframe>'
].join(' '));
const DEFAULT_HW_RATIO = 9 / 16; // 16:9 高宽比

function iFrameVideo(field, options) {
  assert(options.viewWidth, 'viewWidth not found');
  const maxWidth = options.viewWidth;

  let width = Number(field.width);
  let height = Number(field.height);

  if (width <= 0 || height <= 0) {
    height = maxWidth * DEFAULT_HW_RATIO;
  } else {
    height = Math.floor(height * (maxWidth / width));
  }
  width = maxWidth;

  /* eslint prefer-template:0 */
  const src = field.sVal.replace(/(\?|&(amp;)*width)=\d+/, '$1=' + width)
    .replace(/(\?|&(amp;)*height)=\d+/, '$1=' + height);
  return ifrTmpl({
    src: _.escape(src),
    width,
    height
  });
}

module.exports = iFrameVideo;



// WEBPACK FOOTER //
// ./src/HTMLTag/iframe-video.js